/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { Component, OnInit, ViewChild } from '@angular/core';
import { ConfigAssetLoaderService } from '../../../services/config-asset-loader.service';
import { LoginService } from '../../../services/login.service';
import { DataTableDirective } from 'angular-datatables';
import { Router } from '@angular/router';
import { CommonFuntions } from '../../../common/common.function';

declare let $: any;

@Component({
  selector: 'app-interpreter-role',
  templateUrl: './interpreter-role.component.html',
  styleUrls: ['./interpreter-role.component.css']
})
export class InterpreterRoleComponent implements OnInit {

  @ViewChild(DataTableDirective, {static: true})
  datatableElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  token = 'Bearer ' + localStorage.getItem('token');
  valueToSearch: string;
  errorString: string;

  title: string;
  searchValue = '';

  userCount: number
  activeUsers: number
  inactiveUsers: number

  constructor(
    public router: Router,
    private loginService: LoginService
  ) {
    this.userCount = 0;
  }

  ngOnInit() {
    this.title = 'Interpreter Role';

    const user = this.loginService.getCurrentUser();

    const optionObject = {
      ajax: {
        url: ConfigAssetLoaderService.getApiURL() + '/user/role/7?type=' + user.user_type.type + '&userid=' + user.user_id,
        dataSrc: function(json) {
          this.userCount = json.recordsTotal;
          this.activeUsers = json.activeCount || 0;
          this.inactiveUsers = json.inActiveCount || 0;
          return json.data;
        }.bind(this),
        type: 'POST',
        beforeSend: function (xhr) {
          if (!CommonFuntions.guardForAction(this.loginService, this.router)) {
            xhr.abort();
            return;
          }

          this.errorString = null;
          const token = localStorage.getItem('token');
          xhr.setRequestHeader('Authorization', 'Bearer ' + token);
        }.bind(this),
        error: this.datatablesError.bind(this)
      },
      pagingType: 'full_numbers',
      serverSide: true,
      processing: true,
      lengthChange: false,
      searching: true,
      pageLength: 25,
      order: [[0, 'ASC']],
      info: false,
      stateSave: true,
      stateDuration: 5 * 60,
      rowCallback: (row: Node, data: any[] | Object, _index: number) => {
        // Unbind first in order to avoid duplicate handler
        $('td', row).unbind('click');
        $('td', row).bind('click', function () {
          this.viewUserInfo(data);
        }.bind(this));
      }
    };

    optionObject['columns'] = this.getColumn(user);

    this.dtOptions = optionObject;

    this.setSearchValueFromSavedState();
  }
  datatablesError(xhr, _error, _thrown) {
    const errorStatus = xhr.status;
    if (errorStatus == 401) {
      this.router.navigate(['/login']);
    }
    else if (errorStatus == 404) {
      this.errorString = 'Invalid Url';
    }
    else {
      this.errorString = 'Problem occurred. Please contact your administrator';
    }
  }

  search() {
    this.datatableElement.dtInstance.then(
      (dtInstance: DataTables.Api) => {
        dtInstance.search(this.valueToSearch).draw();
      }
    );
  }

  searchString(searchValue: string) {
    this.valueToSearch = searchValue;
    this.search();
  }

  viewUserInfo(info: any) {
    // if(this.user)
    this.router.navigate(['/profile', info.user_id]);

  }

  private getColumn(user: any) {
    let columns;

    if (user.user_type.type.toLowerCase() === 'admin' ||
      user.user_type.type.toLowerCase() === 'careteam') {
      columns = [
        {
          title: 'Name',
          render: function (_data, _type, row, _meta) {
            return $.fn.dataTable.render.text().display(row.full_name);
          }
        },
        {
          title: 'Language',
          render: function (_data, _type, row, _meta) {
            const languages = [];

            if (!row.user_languages || row.user_languages.length == 0) {
              return '';
            }

            row.user_languages.forEach(language => {
              languages.push($.fn.dataTable.render.text().display(language.language.language));
            });

            let list = '';
            languages.forEach(language => {
              list = list + '<li>' + language + '</li>';
            });

            return '<ul>' + list + '</ul>';
          }
        },
        {
          title: 'Phone Number',
          render: function (_data, _type, row, _meta) {
            if (!row.phone_number || row.phone_number === '') {
              return '';
            }

            return $.fn.dataTable.render.text().display(row.phone_number);
          }
        },
        {
          title: 'Email',
          render: function (_data, _type, row, _meta) {
            return $.fn.dataTable.render.text().display(row.email);
          }
        },
        {
          title: 'Status',
          render: function (_data, _type, row, _meta) {
            if (row.is_deleted) {
              return 'Inactive';
            }
            else {
              return 'Active';
            }
          },
          orderable: false
        }
      ];
    }

    return columns;
  }

  setSearchValueFromSavedState() {

    const state = localStorage.getItem('DataTables_interpreter_/interpreter-role');

    if (state == null) {
      this.searchValue = '';
      return;
    }

    const searchValue = JSON.parse(state).search['search'];

    if (searchValue != null) {

      this.searchValue = searchValue;

    }
  }
}
